import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Star } from 'lucide-react';

export default function Testimonials() {
  const { isDark } = useTheme();

  const testimonials = [
    {
      name: "Thomas Martin",
      role: "Directeur Commercial, TechCall",
      content: "Insight360 a transformé notre façon de manager. +40% de productivité en 3 mois.",
      rating: 5,
      image: "TM"
    },
    {
      name: "Sophie Bernard",
      role: "Manager d'équipe, SalesForce",
      content: "La visibilité en temps réel sur mon équipe a changé la donne. Je recommande.",
      rating: 5,
      image: "SB"
    },
    {
      name: "Marc Dubois",
      role: "CEO, CallExpert",
      content: "Le meilleur investissement CRM que nous ayons fait. ROI atteint en 2 mois.",
      rating: 5,
      image: "MD"
    }
  ];

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className={`text-3xl lg:text-4xl font-bold mb-4 ${
            isDark ? 'text-white' : 'text-gray-900'
          }`}>
            Ils nous font confiance
          </h2>
          <p className={`text-lg ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            Rejoignez les 500+ équipes qui ont transformé leur performance
          </p>
        </div>

        {/* Logos clients (placeholder) */}
        <div className="flex flex-wrap justify-center gap-8 mb-16 opacity-50">
          {[1,2,3,4,5].map(i => (
            <div key={i} className={`w-24 h-12 rounded-lg ${
              isDark ? 'bg-gray-800' : 'bg-gray-200'
            }`}></div>
          ))}
        </div>

        {/* Témoignages */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`p-6 rounded-2xl border ${
                isDark 
                  ? 'bg-gray-900 border-gray-800' 
                  : 'bg-white border-gray-200'
              }`}
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Content */}
              <p className={`text-lg mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-500 to-purple-600 flex items-center justify-center text-white font-bold">
                  {testimonial.image}
                </div>
                <div>
                  <p className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                    {testimonial.name}
                  </p>
                  <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}